import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";

const CoinButton = ({ children, disabled, onClick, ...props }: any) => {
  return <Button {...props}>{disabled ? "..." : children}</Button>;
};
export default CoinButton;
